import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { ApiHelper } from './apiHelper';

@Injectable()
export class SocketService extends Socket {
  constructor(private apiHelper: ApiHelper) {
    super({ url: apiHelper.getServiceName('data'), options: { transports: ['websocket'] } });

    this.ioSocket.onAny((event: string, ...args: any[]) => {
      console.log("📡 Event from server:", event, args);
    });

    this.ioSocket.on("connect", () => {
      console.log("✅ Connected to server with id:", this.ioSocket.id);
      this.ioSocket.emit("ping-test", { time: Date.now() });
      console.log("📤 Sent ping-test");
    });

    this.ioSocket.on("connect_error", (err: any) => {
      console.error("❌ Connect error:", err);
    });

    this.ioSocket.on('pong-test', () => {
      console.log('pong received!')
    })

  }
}
